import vue from 'vue'

export const globalObservableStore = vue.observable({
  activeTimerModal: false
})

export const mutation = {
  setActiveTimerModal: (activeModal) => {
    globalObservableStore.activeTimerModal = activeModal
  }
}
